import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { ReportService } from '../../service/report.service';
import { ToplineService } from '../../service/topline.service';
// import {Observable} from 'rxjs';
// import {startWith, map} from 'rxjs/operators';
import { ExcelViewerService } from '../../service/excel-viewer.service';
// import { E } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-topline-parameters',
  templateUrl: './topline-parameters.component.html',
  styleUrls: ['./topline-parameters.component.scss']
})
export class ToplineParametersComponent implements OnInit, OnDestroy {
  @ViewChild('topcutTreeSelect', {static: false}) topcutTree :ElementRef;
  control = new FormControl('');
  streets: string[] = ['Table', 'Table1', 'Miraj', 'Faiz','Gurpreet','Priyanka','Shikha','Ambuj'];
  public ErrorMsg:string;
  public currentClickedTab:any;
  public currentTabValue:any;
  public customOptionPriority:number[] = [];
  public treeSortManager:any = {"sidecut":false,"topcut":false,"table":false,customOption:[]}
  // public table_definition : any = {"topcut":[],"table":[]};
  // public hardCopySideCut:any;
  constructor(
    public reportService:ReportService,
    public notifier: NotifierService,
    private formBuilder: FormBuilder,
    public toplineService:ToplineService,
    public evService: ExcelViewerService
  ) { 
    
  }
  ngOnDestroy(): void {
    this.toplineService.sidecutArrayForPriority = [];
  }

  ngOnInit(): void {
    this.toplineService.currentTableRowsThatHasStyle = {};
    this.toplineService.filterStreetData  = this.toplineService.tableListForToplineParams;
    this.toplineService.insertSheetItem();
    this.toplineService.activeTreeTab = 'top cuts';
  }



  filterData(text:any){
    this.toplineService.filterStreetData = this.toplineService.tableListForToplineParams.filter((table:any) =>{
      return this._normalizeValue(table.name).includes(this._normalizeValue(text))
    })
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  onSubmit(){
    // console.log("toplineService.currentTable['sidecut'] =====> ",this.toplineService.currentTable['sidecut'])
    // console.log("toplineService.currentTable['tablecut'] =====> ",this.toplineService.currentTable['tablecut'])
    if(this.validation())
    {
      if (this.radioValidation("error")) {
        this.setCurrentTableJSON();
      }
    }else{
      this.notifier.notify('error',this.ErrorMsg)
    }
  }


  validation(){
    if(!this.toplineService.currentTable['table_name'] && this.toplineService.currentTable['table_name'] == ''){
      this.ErrorMsg = 'Select table name'
      return 0;
    }
    else if(this.toplineService.currentTable['topcut'].length == 0 ){
      this.ErrorMsg = 'Select topcut value';
      return 0;
    }
    else if(this.toplineService.currentTable['sidecut'].length == 0){
      this.ErrorMsg = 'Select sidecut value';
      return 0;
    }
    else if(this.toplineService.currentTable['tablecut'].length == 0){
      this.ErrorMsg = 'Select tablecut value';
      return 0;
    }
    else if(this.toplineService.currentTable['custom_options'].length){
      this.ErrorMsg = 'Please fill Current Custom Option Field';
      return this.validateCustomOptions(this.toplineService.currentTable['custom_options']);
    }
    return 1;
  }

  radioValidation(notifierType){
    if (this.toplineService.currentTable['topcutValue'] == this.toplineService.currentTable['sidecutValue'] && this.toplineService.currentTable['topcutValue'] !="") {
      this.notifier.notify(notifierType,"Top Cut and Side Cut both have same selection")
      return false;
    }
    if (this.toplineService.currentTable['topcutValue'] == this.toplineService.currentTable['tablecutValue'] && this.toplineService.currentTable['topcutValue'] !="") {
      this.notifier.notify(notifierType,"Top Cut and Values both have same selection")
      return false;
    }
    if (this.toplineService.currentTable['sidecutValue'] == this.toplineService.currentTable['tablecutValue'] && this.toplineService.currentTable['sidecutValue'] !="") {
      this.notifier.notify(notifierType,"Top Side Cut and Values both have same selection")
      return false;
    }
    return true;
  }

  // addToTableDefinition(uuid,type){
  //   let hasDublicate = "";
  //   // hasDublicate = this.table_definition.find(def_uuid => { return def_uuid === uuid});
  //   hasDublicate = this.table_definition[type].find(def_uuid => { return def_uuid === uuid});
  //   if (!hasDublicate || hasDublicate ==="") {
  //     this.table_definition[type].push(uuid)
  //     // this.table_definition.push(uuid)
  //   }
  // }
  
  setCurrentTableJSON(){
    let currentTable=this.toplineService.currentTable;
    this.customOptionPriority = [];
    // console.log("currentTable in topline parameters =====> ", currentTable);    
    // console.log("currentTableRowsThatHasStyle in topline parameters =====> ", this.toplineService.currentTableRowsThatHasStyle);    
    // this.table_definition = {'topcut':[],'table':[]}
    let selectedSidecutIds = [];
    let invalidCustomOption = false;
    this.evService.table_definition = {'topcut':[],'table':[]}
    let currentTableJson = {"topcut":{},"sidecut":{},"values":{},"selected_tables":[],"table_definition":[]};
    let tableContainsIn = currentTable.topcutValue == "table" ? "topcut" : currentTable.sidecutValue == "table" ? "sidecut" : "tablecut";
    currentTableJson.selected_tables = [];
    currentTable[tableContainsIn].forEach(option => {
      currentTableJson.selected_tables.push(option.uuid)
    });
    if (this.toplineService.table_id && this.toplineService.table_id != "") {
      currentTableJson["table_id"] = this.toplineService.table_id;
    }
    currentTableJson["topcut"] = {"value_type":currentTable.topcutValue,"values":{}};
    currentTableJson["sidecut"]= {"value_type":currentTable.sidecutValue,"values":{}};
    currentTableJson["values"]= {"value_type":currentTable.tablecutValue,"values":{}};
    if (currentTable.topcutValue == "topcut") {
      // currentTableJson["topcut"]["values"] = this.getTreeFormat(currentTable["topcut"],"topcut")
      currentTableJson["topcut"]["values"] = this.evService.getTreeFormat(currentTable["topcut"],"topcut")
    }else{
      currentTable["topcut"].forEach((tCut, index) => {
        // this.addToTableDefinition(tCut.uuid,"topcut");
        this.evService.addToTableDefinition(tCut.uuid,"topcut");
        currentTableJson["topcut"]["values"][tCut.uuid] = tCut
        currentTableJson["topcut"]["values"][tCut.uuid]["index"] = index + 1;
      });
    }
    // let priorityIteration = 0
    if(currentTable.custom_options.length){
      currentTableJson['custom_options'] = currentTable['custom_options'];
      this.customOptionPriority = currentTable['custom_options'].map(item => item.priority);
      currentTable["sidecut"].sort((a,b) => {return a.selectionOrder >= b.selectionOrder ? 1 : -1})
      // console.log("this.customOptionPriority ===> ",this.customOptionPriority)
      // console.log("currentTable['sidecut'] ===> ",currentTable["sidecut"])
    }
    let lastPriority = [0];
    currentTable["sidecut"].forEach((sCut, index) => {
      currentTableJson["sidecut"]["values"][sCut.uuid] = sCut;
      currentTableJson["sidecut"]["values"][sCut.uuid]["index"] = index + 1;
      selectedSidecutIds.push(sCut.id)
      currentTableJson["sidecut"]["values"][sCut.uuid]["priority"] = this.customOptionPriority.length ? this.getPriority(sCut.selectionOrder,lastPriority) : sCut.selectionOrder;
      lastPriority.push(currentTableJson["sidecut"]["values"][sCut.uuid]["priority"]);
      if (this.toplineService.currentTableRowsThatHasStyle[sCut.uuid] && this.toplineService.currentTableRowsThatHasStyle[sCut.uuid] != undefined) {
        currentTableJson["sidecut"]["values"][sCut.uuid]["style"] = JSON.parse(JSON.stringify(this.toplineService.currentTableRowsThatHasStyle[sCut.uuid]["style"]))
      }
      if(sCut && sCut.newV){
        currentTableJson["sidecut"]["values"][sCut.uuid]["newv"] = sCut.newV;
      }
    });

    if (currentTable.tablecutValue == "topcut") {
      // currentTableJson["values"]["values"] = this.getTreeFormat(currentTable["tablecut"],"table")
      currentTableJson["values"]["values"] = this.evService.getTreeFormat(currentTable["tablecut"],"table")
    }else{
      currentTable["tablecut"].forEach((taCut, index) => {
        if (currentTable["tablecut"].length > 1) {
          // this.addToTableDefinition(taCut.uuid,"table");
          this.evService.addToTableDefinition(taCut.uuid,"table");
        }
        currentTableJson["values"]["values"][taCut.uuid] = taCut;
        currentTableJson["values"]["values"][taCut.uuid]["index"] = index + 1;
      });
    }
    if(currentTable.custom_options.length){
      currentTableJson['custom_options'] = [];
      currentTable['custom_options'].forEach(custom_option => {
        let coStatus = false;
        custom_option["options"].forEach(cOption => {
          if (selectedSidecutIds.includes(cOption.id)) {
            coStatus = true
          }
        });
        if (!coStatus) {
          custom_option["options"] = [];
          custom_option["invalidCustomOption"] = true
          invalidCustomOption = true
        }else{
          delete custom_option["invalidCustomOption"];
        }
        currentTableJson['custom_options'].push(custom_option)
      });
      if (invalidCustomOption) {
        this.notifier.notify('warning', "Please select valid options in custom options");
        this.toplineService.switchTreeTabs('side cuts');
        return;
      }
    }
    
    currentTableJson.table_definition = JSON.parse(JSON.stringify(this.evService.table_definition));
    if(currentTable['merge'] && currentTable.merge.length){
      currentTableJson['merge'] = currentTable['merge'];
    }
    if(this.evService.kpiViewerMerge.length){
      currentTableJson['merge'] = this.evService.kpiViewerMerge;
    }

   


    this.toplineService.currentTableJson = {}
    this.toplineService.currentTableJson[currentTable.table_name] = currentTableJson;
    this.toplineService.currentTableRowsThatHasStyle = {};
    this.evService.table_definition = {'topcut':[],'table':[]};
    // console.log("currentTableJson ====> ",currentTableJson)
    this.evService.putTableInPayload();
  }
  getPriority(priority,lastPriority){
    if (this.customOptionPriority.includes(priority)) {
        priority = priority + 1;
        return this.getPriority(priority,lastPriority)
    }else{
      if (lastPriority.includes(priority)) {
        priority = priority + 1;
        return this.getPriority(priority,lastPriority)
      }else{
          return priority
      }
    }
  }

  // getTreeFormat(topcutJson,type){
  //   let topcutTree = [];
  //   let selectedTopCuts = [{"options":topcutJson}]
  //   selectedTopCuts.forEach(top => {
  //    let topcutObj = {};
  //    topcutObj['id'] = this.findID(top.options);
  //    topcutObj['topcut'] = {};
  //    top.options.forEach( option => {
  //      let splitOption = option['parent'].split('---');
  //      let splitParentName = option['parentName'].split('---');
  //      if (option['sType'] && option['sType'] == "All") {
  //        // isAllTopcut = true;
  //      }else{
  //       if (option['name']) {
  //         splitParentName.push(option['name']);
  //       }
  //       if (option['uuid']) {
  //         splitOption.push(option['uuid']);
  //       }
  //        splitParentName.splice(0,1);
  //        splitOption.splice(0,1);
  //        let map = topcutObj['topcut'];
  //        for (let i = 0; i < splitOption.length; i++) {
  //          let item = splitOption[i]
  //          this.addToTableDefinition(item,type);
  //          map[item] = map[item] || {};
  //          if (Object.keys(map[item]).length > 0 || i < splitOption.length - 1) {
  //            map[item]['type'] = 'topcut';
  //            map[item]['name'] = splitParentName[i]
  //           //  map[item]['parent'] = option['parent'];
  //          }else{
  //            map[item] = option;
  //            map[item]['type'] = 'option';
  //            map[item]['show'] = option.show;
  //           //  map[item]['parent'] = option['parent'];
  //            map[item]['index'] = option["dindex"];
  //          }
  //          map[item]['options'] = map[item]['options'] || {};
  //          map = map[item]['options'];
  //        }
  //      }
  //    });
  //    this.removeEmptyOptions(topcutObj['topcut']);
  //    topcutTree.push(topcutObj);
  //  });
  // //  console.log(topcutTree);
  //   return topcutTree[0]["topcut"]
  // }

  // findID(options){
  //   let len = 0;
  //   let key = '';
  //   options.forEach( (option) => {
  //     const arr = option['parent'].split('---');
  //     if(arr.length > len){
  //       len = arr.length;
  //       key = arr[1];
  //     }
  //   });
  //   return options[0].id.split('-')[0];
  // }
  // removeEmptyOptions(topcutObj){
  //   Object.keys(topcutObj).forEach((key)=>{
  //         if(Object.keys(topcutObj[key]['options']).length == 0){
  //           delete topcutObj[key]['options'];
  //         }else{
  //           this.removeEmptyOptions(topcutObj[key]['options']);
  //         }
  //   })
  // }

  getSelectedParent(topcuts, selectedTopcutOption){
    let parents = [];
    selectedTopcutOption.forEach(option => {
      parents.push(option.p)
    });
    parents = parents.filter(
      (element, i) => i === parents.indexOf(element)
    )
    return parents;
  }

 
  // returnDataTreeItems(datatype:string){
  //   // console.log("this.toplineService.toplineTreeItems['topcut']====>",this.toplineService.toplineTreeItems['topcut'])
  //   if(datatype == 'sidecut'){
  //     this.toplineService.sortTreeItem("sidecut",this.toplineService.currentTable["sidecut"])
  //     return this.toplineService.toplineTreeItems['sidecut']
  //     // let sideTree = JSON.parse(JSON.stringify(this.toplineService.toplineTreeItems['sidecut']))
  //     // return sideTree
  //   }
  //   if(datatype == 'topcut'){
  //     // console.log("this.toplineService.originalToplineTreeItems  $$$$$$$  >>>",this.toplineService.originalToplineTreeItems)
  //     // console.log("this.toplineService.toplineTreeItems  ********  >>>",this.toplineService.toplineTreeItems)
  //     // this.filterTreeBySelectedItems(this.toplineService.toplineTreeItems['topcut'],this.toplineService.currentTable['topcut'])
  //     this.toplineService.sortTreeItem("topcut",this.toplineService.currentTable["topcut"])
  //     return this.toplineService.toplineTreeItems['topcut']
  //   }
  //   if (datatype == 'table') {
  //     this.toplineService.sortTreeItem("table",this.toplineService.currentTable["tablecut"])
  //     return this.toplineService.toplineTreeItems['table']
  //   }
  // }

  returnDataTreeItems(datatype:string, selectedItems){
    if(datatype == 'sidecut'){
      if (!this.treeSortManager.sidecut && this.toplineService.table_id != "") {
        // console.log("sidecut tree sort");
        let tempObj = this.toplineService.sortTreeItem(this.toplineService.toplineTreeItems['sidecut'],"sidecut",selectedItems)
        this.treeSortManager.sidecut = tempObj.isSortingDone;
        return tempObj.tree
      }else{
        return this.toplineService.toplineTreeItems['sidecut']
      }
    }
    if(datatype == 'topcut'){
      console.log("topcut tree sort ",this.toplineService.toplineTreeItems['topcut'])
      if (!this.treeSortManager.topcut && this.toplineService.table_id != "") {
        let tempObj = this.toplineService.sortTreeItem(this.toplineService.toplineTreeItems['topcut'],"topcut",selectedItems)
        this.treeSortManager.topcut = tempObj.isSortingDone;
        return tempObj.tree 
      }else{
        return this.toplineService.toplineTreeItems['topcut']
      }
    }
    if (datatype == 'table') {
      if (!this.treeSortManager.table && this.toplineService.table_id != "") {
        // console.log("table tree sort")
        let tempObj = this.toplineService.sortTreeItem(this.toplineService.toplineTreeItems['table'],"table",selectedItems)
        this.treeSortManager.table = tempObj.isSortingDone;
        return tempObj.tree 
      }else{
        return this.toplineService.toplineTreeItems['table']
      }
    }
  }

  returnDataTreeItemsForCustomOption(datatype:string, selectedItems,optionIndex){
    // this.toplineService.customOptionTree[optionIndex] = [];
    if (!(this.toplineService.customOptionTree[optionIndex] && this.toplineService.customOptionTree[optionIndex].length)) {
      this.toplineService.customOptionTree[optionIndex] = JSON.parse(JSON.stringify(this.toplineService.originalToplineTreeItems[datatype]))
    }
    if (!(this.treeSortManager.customOption && this.treeSortManager.customOption.length && this.treeSortManager.customOption[optionIndex]) && this.toplineService.table_id != "") {
      // console.log("Custom opt sort at index ==> ",optionIndex);
      let tempObj = this.toplineService.sortTreeItem(this.toplineService.customOptionTree[optionIndex],datatype,selectedItems)
      this.treeSortManager.customOption[optionIndex] = tempObj.isSortingDone;
      this.toplineService.customOptionTree[optionIndex] = tempObj.tree;
      return this.toplineService.customOptionTree[optionIndex];
    }else{
      return this.toplineService.customOptionTree[optionIndex];
    }
  }

  // SetSelectedRadioInput(radio_value:string,cut:string,data:any)
  // {
  //   data = radio_value;
  //   this.changeRadioInput(cut);
  // }

  setSelectedRadioInput(radio_value:string,radio_key:string)
  {
    this.toplineService.currentTable[radio_key] = radio_value;
    this.changeRadioInput(radio_value);
  }

  changeRadioInput(type:string){
    switch(type){
      case 'topcut':
        this.toplineService.currentTable.topcut = [];
        break;
      case 'sidecut':
        this.toplineService.currentTable.sidecut = [];
        break;
      default:
        this.toplineService.currentTable.tablecut = [];
        break
    }
    this.radioValidation("warning");
  }

  onNext(){
    this.toplineService.sidecutChangeDetector();
    switch (this.toplineService.activeTreeTab){
      case "top cuts":
        this.toplineService.activeTreeTab = 'side cuts';
        break;
      case "side cuts":
        this.toplineService.activeTreeTab = 'values';
        break;  
    }
  }

  checkCustomOptionsExit(){
    if(this.toplineService.currentTable['sidecut'].length){
      return true
    }
    return false;
  }

  addCustomOption(){
    if(this.toplineService.currentTable['custom_options'] && this.toplineService.currentTable['custom_options'].length == 0){
      this.toplineService.currentTable['custom_options'] = [
        {operation:'',include_formula:false,name:'',options:JSON.parse(this.toplineService.hardCopySideCut)}
      ];
    }
    else{
      if(this.validateCustomOptions(this.toplineService.currentTable['custom_options'])){
        this.toplineService.currentTable['custom_options'].push(
          {operation:'',include_formula:false,name:'',options:JSON.parse(this.toplineService.hardCopySideCut)}
        );
      }else{
        this.notifier.notify('error','Please fill Current Custom Option Field');
      }
    }
  }
  validateCustomOptions(custom_options){
    let custom_arr = custom_options[custom_options.length-1];
    if(custom_arr && custom_arr['operation'] == ''){
      return false;
    }
    if(custom_arr && custom_arr['name'] == ''){
      return false;
    }
    if(custom_arr && !custom_arr['options'].length){
      return false;
    }
    return true;
  }




  setCustomOption(){
    this.toplineService.currentTable['custom_options'] = (this.toplineService.currentTable['custom_options'] && this.toplineService.currentTable['custom_options'].length) ? this.toplineService.currentTable['custom_options'] : [];
    // this.toplineService.currentTable['custom_options'] = [];
    let baseLessSidecut:any[] = this.toplineService.currentTable['sidecut'];
    baseLessSidecut  = baseLessSidecut.filter((va:any) =>{
      return va.name.startsWith('Base') ? false : true;
    })
    this.toplineService.hardCopySideCut = JSON.stringify(baseLessSidecut);
  }

  deletCustomOption(ind){
    this.toplineService.currentTable['custom_options'].splice(ind,1);
    if(this.toplineService.currentTable['custom_options'] && this.toplineService.currentTable['custom_options'].length == 0){
      this.toplineService.currentTable['custom_options'] = []
    }
  }


 


}
